import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GenericDropDownV3, TS_MultiSelect_Sortable, TS_MultiSelect_V2 } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_NoteTemplate } from './ModuleFE_NoteTemplate.js';
import { DBItemDropDownMultiSelector } from '@nu-art/thunderstorm-frontend/components/_TS_MultiSelect/DBItemDropDownMultiSelector';
import { ICONS } from '@app/styles';
const Props_DropDown = {
    module: ModuleFE_NoteTemplate,
    modules: [ModuleFE_NoteTemplate],
    mapper: item => [item.title],
    placeholder: 'Choose a NoteTemplate',
    renderer: item => _jsxs("div", { className: "ll_h_c", children: [" ", item.label, " "] })
};
export const DropDown_NoteTemplate = GenericDropDownV3.prepare(Props_DropDown);
const Props_MultiSelect = DBItemDropDownMultiSelector.propsV3({
    module: ModuleFE_NoteTemplate,
    itemRenderer: (item, onDelete, disabled) => {
        return !item ? _jsx(_Fragment, { children: "Not Found" }) : _jsxs(_Fragment, { children: [!disabled && _jsx(ICONS.x.component, { onClick: onDelete, className: 'ts-icon__small' }), item.label] });
    },
    uiSelector: DropDown_NoteTemplate.selectable,
});
export const MultiSelect_NoteTemplate = {
    editable: TS_MultiSelect_V2.prepare(Props_MultiSelect),
    sortable: TS_MultiSelect_Sortable.prepare(Props_MultiSelect),
};
//# sourceMappingURL=ui-components.js.map